import type { HelpFile } from '../../types/help'
import { SchemaTestIds } from '../../../testids/SchemaTestIds'

export const schemaHelp: HelpFile = {
  docPage: '/docs/schema/overview',
  texts: {
    [SchemaTestIds.schemaWelcomeCard]:
      'Startseite des Schema-Bereichs — wählen Sie ein Werkzeug aus der Seitenleiste: Typen, Attributdefinitionen, Formular-Layouts, Beziehungsschema und Wertelisten.',
  },
}
